module.exports = __webpack_public_path__ + "img/lift-entrance.a788f44f.jpg";